import React, { useState } from 'react';
import { useWeb3, WALLETS, PRO_PERKS } from '../Web3Context';
import { useLang } from '../LangContext';

/* ── WALLET CONNECT MODAL ── */
export function WalletModal({ onClose }) {
  const { connectWallet, connecting, error, wallet, disconnect, displayName, isProHolder } = useWeb3();
  const { lang } = useLang();
  const [step, setStep] = useState(wallet ? 'connected' : 'select'); // 'select' | 'connecting' | 'connected'

  const handleConnect = async (walletId) => {
    setStep('connecting');
    await connectWallet(walletId);
    setStep('connected');
  };

  const handleDisconnect = () => {
    disconnect();
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 300,
      background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(10px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
    }} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={{
        background: '#111', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '20px', padding: '0', maxWidth: '380px', width: '100%',
        overflow: 'hidden',
        animation: 'walletIn 0.3s cubic-bezier(0.16,1,0.3,1)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '1.25rem 1.5rem',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* Web3 cube icon */}
            <div style={{
              width: '32px', height: '32px', borderRadius: '9px',
              background: 'linear-gradient(135deg, #6C47FF, #A855F7)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5">
                <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
              </svg>
            </div>
            <div>
              <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text)', fontFamily: 'var(--font-display)' }}>
                {step === 'connected' ? 'Wallet Connected' : 'Connect Wallet'}
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '1px' }}>
                {step === 'connected' ? 'VidGet Pro NFT Access' : 'Unlock Pro features'}
              </p>
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '8px', width: '32px', height: '32px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'var(--text2)', cursor: 'pointer', fontSize: '16px',
            transition: 'background 0.15s',
          }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
          >×</button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.5rem' }}>
          {step === 'select' && (
            <>
              <p style={{ fontSize: '13px', color: 'var(--text2)', marginBottom: '1.25rem', lineHeight: 1.6 }}>
                Connect your Web3 wallet to unlock <span style={{ color: '#A855F7', fontWeight: 500 }}>VidGet Pro</span> features via NFT ownership.
              </p>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '1.5rem' }}>
                {WALLETS.map((w) => (
                  <button key={w.id} onClick={() => handleConnect(w.id)} style={{
                    display: 'flex', alignItems: 'center', gap: '12px',
                    padding: '12px 14px', borderRadius: '12px',
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    cursor: 'pointer', transition: 'all 0.15s',
                    width: '100%', textAlign: 'left',
                  }}
                    onMouseEnter={e => { e.currentTarget.style.background = 'rgba(108,71,255,0.08)'; e.currentTarget.style.borderColor = 'rgba(108,71,255,0.3)'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                  >
                    <div style={{
                      width: '36px', height: '36px', borderRadius: '9px',
                      background: 'rgba(255,255,255,0.06)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0,
                    }}>{w.icon}</div>
                    <div style={{ flex: 1 }}>
                      <p style={{ fontSize: '14px', fontWeight: 500, color: 'var(--text)' }}>{w.name}</p>
                      <p style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '1px' }}>
                        {w.detected() ? '● Detected' : '○ Not installed'}
                      </p>
                    </div>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--text3)" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </button>
                ))}
              </div>

              {/* Pro perks preview */}
              <div style={{
                background: 'linear-gradient(135deg, rgba(108,71,255,0.1), rgba(168,85,247,0.06))',
                border: '1px solid rgba(108,71,255,0.2)',
                borderRadius: '12px', padding: '1rem',
              }}>
                <p style={{ fontSize: '11px', fontWeight: 600, color: '#A855F7', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '8px' }}>
                  Pro NFT Holder Perks
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {PRO_PERKS[lang]?.slice(0, 4).map((perk, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                      <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#A855F7', flexShrink: 0 }} />
                      <span style={{ fontSize: '12px', color: 'var(--text2)' }}>{perk}</span>
                    </div>
                  ))}
                </div>
              </div>
            </>
          )}

          {step === 'connecting' && (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              <div style={{
                width: '48px', height: '48px', margin: '0 auto 1.25rem',
                border: '2px solid rgba(108,71,255,0.2)',
                borderTopColor: '#A855F7', borderRadius: '50%',
                animation: 'spin 0.9s linear infinite',
              }} />
              <p style={{ fontSize: '14px', fontWeight: 500, color: 'var(--text)', marginBottom: '6px' }}>Connecting wallet...</p>
              <p style={{ fontSize: '12px', color: 'var(--text3)' }}>Approve in your wallet app</p>
              {error && <p style={{ fontSize: '12px', color: '#f87171', marginTop: '12px' }}>{error}</p>}
            </div>
          )}

          {step === 'connected' && wallet && (
            <div>
              {/* Address card */}
              <div style={{
                background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '12px', padding: '1rem', marginBottom: '1rem',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <div style={{
                    width: '40px', height: '40px', borderRadius: '50%',
                    background: 'linear-gradient(135deg, #6C47FF, #A855F7)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '16px',
                  }}>🦊</div>
                  <div>
                    <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--text)' }}>{displayName}</p>
                    <p style={{ fontSize: '11px', color: 'var(--text3)', fontFamily: 'monospace', marginTop: '2px' }}>
                      {wallet.address.slice(0, 14)}...{wallet.address.slice(-8)}
                    </p>
                  </div>
                  <div style={{ marginLeft: 'auto', textAlign: 'right' }}>
                    <p style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>{wallet.balance} ETH</p>
                    <p style={{ fontSize: '11px', color: 'var(--text3)' }}>Ethereum</p>
                  </div>
                </div>

                {/* Pro status */}
                <div style={{
                  padding: '8px 12px', borderRadius: '8px',
                  background: isProHolder ? 'rgba(108,71,255,0.12)' : 'rgba(255,255,255,0.04)',
                  border: `1px solid ${isProHolder ? 'rgba(108,71,255,0.3)' : 'rgba(255,255,255,0.06)'}`,
                  display: 'flex', alignItems: 'center', gap: '8px',
                }}>
                  <div style={{
                    width: '8px', height: '8px', borderRadius: '50%',
                    background: isProHolder ? '#A855F7' : 'var(--text3)',
                    animation: isProHolder ? 'dotPulse 1.5s ease-in-out infinite' : 'none',
                  }} />
                  <span style={{ fontSize: '12px', color: isProHolder ? '#A855F7' : 'var(--text3)', fontWeight: 500 }}>
                    {isProHolder ? '✦ VidGet Pro NFT Holder' : 'No Pro NFT detected'}
                  </span>
                  {!isProHolder && (
                    <a href="#" style={{ marginLeft: 'auto', fontSize: '11px', color: '#A855F7', textDecoration: 'none' }}>
                      Mint →
                    </a>
                  )}
                </div>
              </div>

              {/* Pro perks if holder */}
              {isProHolder && (
                <div style={{
                  background: 'linear-gradient(135deg, rgba(108,71,255,0.1), rgba(168,85,247,0.06))',
                  border: '1px solid rgba(108,71,255,0.2)',
                  borderRadius: '12px', padding: '1rem', marginBottom: '1rem',
                }}>
                  <p style={{ fontSize: '11px', fontWeight: 600, color: '#A855F7', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: '10px' }}>
                    ✦ Your Pro Perks Active
                  </p>
                  {PRO_PERKS[lang]?.map((perk, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#A855F7" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      <span style={{ fontSize: '12px', color: 'var(--text2)' }}>{perk}</span>
                    </div>
                  ))}
                </div>
              )}

              <button onClick={handleDisconnect} style={{
                width: '100%', padding: '10px', background: 'transparent',
                border: '1px solid rgba(255,255,255,0.08)', borderRadius: '10px',
                color: 'var(--text2)', fontSize: '13px', fontFamily: 'var(--font-body)',
                cursor: 'pointer', transition: 'all 0.15s',
              }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(248,113,113,0.3)'; e.currentTarget.style.color = '#f87171'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.color = 'var(--text2)'; }}
              >
                Disconnect wallet
              </button>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes walletIn {
          from { opacity: 0; transform: scale(0.94) translateY(12px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
      `}</style>
    </div>
  );
}

/* ── WALLET BUTTON (for Navbar) ── */
export function WalletButton({ onClick }) {
  const { wallet, isProHolder, displayName } = useWeb3();

  if (wallet) {
    return (
      <button onClick={onClick} style={{
        display: 'flex', alignItems: 'center', gap: '7px',
        background: isProHolder ? 'rgba(108,71,255,0.12)' : 'rgba(255,255,255,0.05)',
        border: `1px solid ${isProHolder ? 'rgba(108,71,255,0.35)' : 'rgba(255,255,255,0.1)'}`,
        borderRadius: '8px', padding: '6px 12px',
        color: isProHolder ? '#A855F7' : 'var(--text2)',
        fontSize: '13px', fontWeight: 500, fontFamily: 'var(--font-body)',
        cursor: 'pointer', transition: 'all 0.15s',
      }}
        onMouseEnter={e => { e.currentTarget.style.background = isProHolder ? 'rgba(108,71,255,0.2)' : 'rgba(255,255,255,0.09)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = isProHolder ? 'rgba(108,71,255,0.12)' : 'rgba(255,255,255,0.05)'; }}
      >
        <div style={{
          width: '7px', height: '7px', borderRadius: '50%',
          background: isProHolder ? '#A855F7' : '#22c55e',
        }} />
        {isProHolder && <span style={{ fontSize: '11px' }}>✦</span>}
        {displayName}
      </button>
    );
  }

  return (
    <button onClick={onClick} style={{
      display: 'flex', alignItems: 'center', gap: '6px',
      background: 'rgba(108,71,255,0.1)',
      border: '1px solid rgba(108,71,255,0.25)',
      borderRadius: '8px', padding: '6px 12px',
      color: '#A855F7', fontSize: '13px', fontWeight: 500,
      fontFamily: 'var(--font-body)', cursor: 'pointer', transition: 'all 0.15s',
    }}
      onMouseEnter={e => { e.currentTarget.style.background = 'rgba(108,71,255,0.18)'; e.currentTarget.style.borderColor = 'rgba(108,71,255,0.45)'; }}
      onMouseLeave={e => { e.currentTarget.style.background = 'rgba(108,71,255,0.1)'; e.currentTarget.style.borderColor = 'rgba(108,71,255,0.25)'; }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="7" width="20" height="14" rx="2"/>
        <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/>
        <line x1="12" y1="12" x2="12" y2="16"/>
        <circle cx="12" cy="12" r="1" fill="currentColor"/>
      </svg>
      Connect Wallet
    </button>
  );
}
